import { request } from 'api/api';
import { API } from 'config/api/apiUrls';

export const saveDeviceToken = async ({
  device_token,
  user_email,
}: {
  device_token: string;
  user_email: string;
}) => request.post(API.save_device_token, { device_token, user_email });
